import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type CardTone = "default" | "soft" | "flagged" | "approved" | "danger" | "info";

const toneClasses: Record<CardTone, string> = {
  default: "bg-white border border-[#e2e8f0]",
  soft: "bg-[#f8fafc] border border-[#e2e8f0]",
  flagged: "bg-[#fffbeb] border border-[#fed7aa]",
  approved: "bg-[#f0fdf4] border border-[#bbf7d0]",
  danger: "bg-[#fef2f2] border border-[#fecaca]",
  info: "bg-[#e6f1fb] border border-[#bfdbfe]",
};

interface CardProps {
  tone?: CardTone;
  hoverable?: boolean;
  padding?: "sm" | "md" | "lg" | "none";
  className?: string;
  children: ReactNode;
}

export function Card({ tone = "default", hoverable, padding = "md", className, children }: CardProps) {
  const paddingClass =
    padding === "none" ? "" :
    padding === "sm" ? "p-4" :
    padding === "lg" ? "p-8 sm:p-10" :
    "p-6";

  return (
    <div
      className={cn(
        "rounded-[20px] shadow-[0_2px_16px_rgba(0,0,0,0.04)] transition-shadow duration-200",
        toneClasses[tone],
        hoverable && "hover:shadow-[0_4px_24px_rgba(0,0,0,0.08)]",
        paddingClass,
        className,
      )}
    >
      {children}
    </div>
  );
}
